import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

function isPresent(obj) {
  return obj !== null && obj !== undefined;
}

export class DataTypeValidator {
  static isString(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      if (!isPresent(control.value)) {
        return null;
      }

      return typeof control.value !== 'string' ? { notString: true } : null;
    };
  }

  static isNumber(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      if (control.value === null || control.value === undefined || control.value === '') {
        return null;
      }

      const numberValue = Number(control.value);
      const isInvalid = Number.isNaN(numberValue);

      return isInvalid ? { notNumber: true } : null;
    };
  }
}
